import {
  loadGeneralSettings,
  saveGeneralSettings,
  saveImage,
} from "../services/generalSettingsService";
export const APPLY_GENERAL_SETTINGS = "APPLY_GENERAL_SETTINGS";
export const SAVE_GENERAL_SETTINGS = "SAVE_GENERAL_SETTINGS";
export const LOAD_GENERAL_SETTINGS = "LOAD_GENERAL_SETTINGS";

const initState = {
  type: "image",
  background: {
    type: "",
  },
  // image: img,
  image: "",
  ten_frames_scorecard: true,
  compact_scorecard: true,
  list_players_top: true,
  list_players_last_three: true,
  list_players_top_low: true,
};

export function generalSettings(store) {
  store.on("@init", () => {
    return { generalSettings: initState };
  });

  store.on(LOAD_GENERAL_SETTINGS, async ({ auth }, { history }) => {
    if (auth) {
      const res = await loadGeneralSettings(auth);
      if (res.success === false && res.message === "Not Valid Token") {
        history.push("/login");
      } else {
        store.dispatch(APPLY_GENERAL_SETTINGS, res.settings);
      }
    }
  });

  store.on(APPLY_GENERAL_SETTINGS, ({ generalSettings }, data) => {
    localStorage.setItem("generalSettings", JSON.stringify({ ...data }));
    return { generalSettings: { ...data, ...data.background } };
  });

  store.on(
    SAVE_GENERAL_SETTINGS,
    async ({ generalSettings, auth }, { data, image, history }) => {
      try {
        if (auth) {
          if (image) {
            const body = new FormData();
            body.append("file", image);
            const urlImage = await saveImage(auth, body);
            data.settings.background.image = urlImage.url;
          } else {
            if (data.settings.background.type === "image") {
              data.settings.background.image = generalSettings.image;

              if (!generalSettings.image) {
                data.settings.background.type = "color";
                data.settings.background.color = generalSettings.color;
              }
            }
          }

          const res = await saveGeneralSettings(auth, data);
          store.dispatch(APPLY_GENERAL_SETTINGS, res.settings);
          history.push("/live-score-players");
        }
      } catch (error) {
        console.log(error);
      }
    }
  );
}
